module.exports = __webpack_public_path__ + "img/huaban[1].a883368e.svg";